import { useEffect, useRef } from "react";

import { AppEventTokenEnum, sendEventToAppMeasurementTool } from "@/utilities/capacitorLogic";

type AppEventParams = { [key: string]: string | number | boolean };

/**
 * 渡された token の計測イベントを送る。token が変わるたびに送信し、undefined の間は送らない。
 *
 * MEMO: 計測イベントの送信がすべてこの hook を経由しているわけではない。API の成否など
 *       レンダリングに紐づかない送信は sendEventToAppMeasurementTool を直接呼んでいる。
 */
export const useSendAppEvent = (token: AppEventTokenEnum | undefined, params?: AppEventParams): void => {
  // params をオブジェクトのまま依存配列に入れると毎レンダー再送されるため、ref 経由で最新値を読む
  const paramsRef = useRef(params);
  paramsRef.current = params;

  useEffect(() => {
    if (!token) return;
    sendEventToAppMeasurementTool(token, paramsRef.current);
  }, [token]);
};
